export default "dist/images/block-image-box-fade.e47d3e8.png";